<template>
  <div class="md:px-10 py-2 w-full">
    <div class="bg-blue-800 rounded">
      <div class="shadow pt-1 border-gray-200">
        <div class="bg-white border mt-1 inline flex rounded-xl"></div>
        <table
          style="width: 100px; height: 115px; overflow: scroll border-collapse:inherit"
          class="min-w-full uppercase bg-white"
        >
          <div class="grid grid-cols-10 bg-blue-800 text-white text-center">
            <th class="text-left px-1 uppercase font-semibold text-sm">
              Pedido N°
            </th>
            <th class="text-center px-4 uppercase font-semibold text-sm">
              Cedula
            </th>
            <th class="text-center px-4 uppercase font-semibold text-sm">
              Nombre
            </th>
            <th class="text-center px-4 uppercase font-semibold text-sm">
              Fecha
            </th>
            <th class="text-center px-4 uppercase font-semibold text-sm">
              Valor
            </th>
            <!-- <th class="text-center px-4 uppercase font-semibold text-sm">-
                Iva
              </th>
               -->
            <th class="text-center px-4 uppercase font-semibold text-sm">
              N° guia
            </th>
            <th class="text-center px-4 uppercase font-semibold text-sm">
              Despachado
            </th>
            <th class="text-center px-4 uppercase font-semibold text-sm">
              Fecha Despacho
            </th>
            
            <th class="text-center px-4 uppercase font-semibold text-sm">
              Transportista
            </th>
            <!--   <th class="px-4 uppercase font-semibold text-sm"></th>-
              <th class="px-4 uppercase font-semibold text-sm"></th>
           -->
            <th class="px-4 uppercase font-semibold text-sm"></th>
          </div>
          <tbody class="text-gray-700 divide-y-2 border rounded">
            <tr
              class="
                grid grid-cols-10
                bg-gray-100
                border border-gray-200
                hover:bg-white
                divide divide-x divide-gray-200
              "
              :key="api.idpedido"
              v-for="api in pedido"
            >
              <td class="text-left px-4 w-10">
                {{ api.idpedido }}
              </td>
              <td class="text-center">
                {{ api.cedulaCliente }}
              </td>
              <td class="text-center">
                {{ api.nombre }}
              </td>
              <td class="text-center">
                {{ api.fechaingresopedido.substring(0, 10) }}
              </td>
              <td class="text-center">
                {{ api.valorpedido }}
              </td>
              <!--<td class="text-center">
                {{ api.valoriva }}
              </td>-->
              <td class="text-center">
                {{ api.guia }}
              </td>
              <td class="text-center">
                <a v-if="api.despachado">Si</a>
                <a v-if="!api.despachado">No</a>
              </td>
              <td class=" text-center">
                {{ api.fechadespachopedido.substring(0, 10) }}
                {{ api.fechadespachopedido.substring(11,16) }}
              </td>
              <td class="text-center">
                {{ api.nombreTransportista }}
              </td>

              <td class="text-center grid grid-cols-3 flex justify-center">
                <div class="tooltip">
                  <p class="tooltiptext text-xs">Detalle Pedido</p>
                  <button
                    @click="metodos(api)"
                    class="
                      text-black
                      mt-2
                      p-1
                      hover:bg-blue-400
                      ring-2 ring-blue-500
                      rounded
                    "
                  >
                    <a class="" href="#modalDetalle">
                      <img
                        width="20"
                        src="https://img.icons8.com/ios/452/paid-bill.png"
                        alt=""
                      />
                    </a>
                  </button>
                </div>

                <div class="tooltip">
                  <p class="tooltiptext text-xs">Transportistas</p>
                  <button
                    @click="cargardatostransportistas(api)"
                    class="
                      text-black
                      mt-2
                      p-1
                      hover:bg-red-400
                      ring-2 ring-red-500
                      rounded
                    "
                  >
                    <a class="" href="#modaldatostransportista">
                      <img
                        class="animate-bounce"
                        src="https://image.flaticon.com/icons/png/128/57/57490.png"
                        width="20"
                        alt=""
                      />
                      <hr id="color" />
                    </a>
                  </button>
                </div>

                <div class="tooltip">
                  <p class="tooltiptext text-xs">Imprimir</p>
                  <button
                    @click="datosdetalles(api)"
                    class="
                      text-black
                      mt-2
                      p-1
                      hover:bg-green-400
                      ring-2 ring-green-500
                      rounded
                    "
                  >
                    <img
                      width="20"
                      src="https://img.icons8.com/ios/452/print--v1.png"
                      alt=""
                    />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
//import axios from "axios"; modalDetalle.vue
//import modalDetalle from "../modales/modalDetalle.vue";
import { mapState, mapMutations } from "vuex";

export default {
  name: "tablaPedidos",
  //components: { modalDetalle },
  data() {
    return {
      apis: "",
      elemento: "",
      aux2: [],
      buscar: "",
      falso: false,
      falso1: true,
      id: "",
      descripcion: "",
    };
  },
  computed: {
    ...mapState(["numero"]),
    ...mapState("pedidos", [
      "mensaje",
      "pedido",
      "categoria",
      "descripcionmodal",
      "len",
    ]),
  },

  methods: {
    metodos(api) {
      this.detallepedidos(api);

      setTimeout(() => {
        this.detallepedidos(api);
      }, 300);

      setTimeout(() => {
        if (this.len === 0) {
          this.$notify({
            group: "foo",
            title: "MENSAJE IMPORTANTE",
            text: "SIN PRODUCTOS!",
            type: "warn",
          });
        }
      }, 400);
    },
    /*   async recargar(id) {
      await this.eliminar(id);
      setTimeout(() => {
        this.cargardatospedidos();
      }, 500);
    },*/

    ...mapMutations("pedidos", [
      "eliminar",
      "detallepedidos",
      "datosmodal",
      "cargardatospendientes",
      "cargardatostransportistas",
      "LoadProductos",
      //"cargardatospedidos",
      "cambiarmensaje",
    ]),
  },
};
</script>
<style scoped >
.modal-contenido {
  background-color: rgb(255, 255, 255);
  width: 500px;
  height: auto;

  margin: auto;
  margin-top: 100px;
  position: relative;
}
.modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.1s;
}

/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  /*border-bottom: 1px dotted rgb(255, 118, 118); /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 100px;
  background-color: rgb(0, 0, 0);
  color: #fff;
  text-align: center;
  padding: 3px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 80%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: rgb(0, 0, 0) transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
.header_fijo {
  width: 750px;
  table-layout: fixed;
  border-collapse: collapse;
}

.header_fijo thead tr {
  display: block;
  position: relative;
}
.header_fijo tbody {
  display: block;
  overflow: auto;
  width: 100%;
  height: 400px;
}
hr#color {
  border-top: 2px solid rgb(0, 0, 0);
}
</style>